import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { UserContext } from './App';
import { DashNav } from './components/dashboard/navbar';

const ProtectedRoutes = () => {
  const { auth } = useContext(UserContext)
  if (!auth) {
    return <Navigate to="/login" />
  } else {
    return (
      <div id="container" className="innerContainer mx-auto flex gap-x-10 min-h-lvh">
        <div className="w-full py-[100px] space-y-6">
          <DashNav />
          <Outlet />
        </div>
      </div>
    )
  }
};

export default ProtectedRoutes;